import { Trans } from '@lingui/macro';
import { Drawer } from 'antd';
import AuditModuleActions from 'bukku/redux/AuditModule/actions';
import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { usePrevious } from '../../../helpers/useReadStateSuccess';
import { AuditName } from '../../../redux/AuditModule/enums';
import AuditsTable from './AuditsTable';

const selectorFn = state => {
    const {auditsDrawerOpen, currentAuditName} = state.AuditModule;
    return {
        auditsDrawerOpen,
        currentAuditName, // the current audit name (based on drawer opened)

        auditId: state.AuditModule[currentAuditName]?.auditId || false,
        audits: state.AuditModule[currentAuditName]?.audits || [],
    };
};

export default function AuditsDrawer() {
    const {
        auditId, audits, auditsDrawerOpen, currentAuditName,
    } = useSelector(selectorFn, shallowEqual);

    const {
        toggleAuditsDrawer,
        resetAudit,
        resetAuditId,
    } = AuditModuleActions.withAuditName(currentAuditName);

    const dispatch = useDispatch();

    const location = useLocation();
    const currentPath = location.pathname;
    const prevPath = usePrevious(currentPath);

    // Reset audit and selected audit id when path changes
    useEffect(() => {
        if (currentPath !== prevPath) {
            dispatch(resetAudit());
            dispatch(resetAuditId());
        }
    }, [currentPath, prevPath, resetAudit, resetAuditId, dispatch]);

    const onDrawerClose = () => {
        dispatch(toggleAuditsDrawer(false));
    };

    const getDrawerTitle = () => {
        switch (currentAuditName) {
            case AuditName.ACCOUNT:
                return <Trans>History - Account</Trans>;
            case AuditName.CONTACT:
                return <Trans>History - Contact</Trans>;
            case AuditName.PRODUCT:
                return <Trans>History - Product</Trans>;
            default:
                return <Trans>History</Trans>;
        }
    };

    return (
        <Drawer
            title={getDrawerTitle()}
            placement="right"
            closable
            open={auditsDrawerOpen}
            onClose={onDrawerClose}
            bodyStyle={{
                padding: '8px 4px',
            }}
        >
            {/* <pre>{JSON.stringify(audits || {}, null, 2)}</pre> */}
            <AuditsTable
                auditName={currentAuditName}
                id={auditId}
                audits={audits}
            />
        </Drawer>
    );
}
